import React from "react";

import { IconButton, Menu, MenuItem } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";

const AppMenu = ({ ...props }) => {
  const { anchorEl, handleClose, handleMenu, role } = props;
  const open = Boolean(anchorEl);
  return (
    <div>
      <IconButton aria-owns={open ? "menu-appbar" : null} aria-haspopup="true" onClick={handleMenu} color="inherit">
        <MenuIcon />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        open={open}
        onClose={() => handleClose()}>
        <MenuItem onClick={path => handleClose("dashboard")}>dashboard</MenuItem>
        <MenuItem onClick={path => handleClose("account")}>my account</MenuItem>
        {role === "client" ? <MenuItem onClick={path => handleClose("logs")}>logs</MenuItem> : null}
      </Menu>
    </div>
  );
};

export default AppMenu;



// WEBPACK FOOTER //
// ./src/components/ToolBar/AppMenu.js